// extracted by mini-css-extract-plugin
export default {"overlay":"Ry-z","bodyOpen":"Sy-z","content":"Ty-z","header":"Uy-z","close":"Vy-z","closeNoHeading":"Wy-z"};